import React from "react";
import Table from "./Table";
import { Form } from "./Form";
import formWithMessages from "./hoc/formWithMessages";

const ERROR_EMPTY = "empty_field";
const ERROR_BAD_FORMAT_EMAIL = "email_bad_format";

const validateEmail = candidate => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!re.test(String(candidate).toLowerCase())) return ERROR_BAD_FORMAT_EMAIL;
  return undefined;
};

const AddForm = formWithMessages(
  ({ title, onAdd, helpText, email, disabled, messagesProps }) => (
    <Form
      formProps={{
        id: `add-${title.toLowerCase()}`,
        horizontal: true,
      }}
      onSubmit={formData => onAdd(formData.newValue)}
      {...messagesProps}
      fields={{
        newValue: {
          uiProps: {
            type: "text",
            placeholder: title,
            maxLength: 100,
          },
          position: 1,
          initialValue: "",
          label: `Add ${title} `,
          hoverHelp: () => helpText,
        },
      }}
      validation={formData => {
        if (!formData.newValue) return ERROR_EMPTY;
        if (email) return validateEmail(formData.newValue);
        return undefined;
      }}
      submitButtonProps={{
        disabled,
        children: "Save",
        bsStyle: "primary",
      }}
      errorMessages={{
        [ERROR_EMPTY]: "The field cannot be empty!",
        [ERROR_BAD_FORMAT_EMAIL]:
          "The email address entered is invalid, please enter a new email address!",
      }}
    />
  ),
);

export default props => {
  const { title, data, onDelete, ...addFormProps } = props;
  const actions = [
    {
      id: `remove-${title.toLowerCase()}`,
      disabled: value =>
        data.find(row => row.value === value && row.deleteInProgress) !==
        undefined,
      text: " Delete",
      className: "btn-danger",
      glyph: "glyphicon glyphicon-trash",
      onClick: onDelete,
    },
  ];
  const columns = [
    {
      header: "",
      data: row => row.value,
    },
  ];
  return [
    <AddForm key="form" title={title} {...addFormProps} />,
    <br key="spacing" />,
    <Table
      key="table"
      data={data}
      columns={columns}
      actions={actions}
      identityProperty="value"
      noDataMessage="No data"
    />,
  ];
};



// WEBPACK FOOTER //
// ./src/sc/ui/components/TableWithAddForm.js